function burgerMenu(lenis) {
  const burger = document.querySelector(".js-burger");
  const header = document.querySelector(".l-header");
  const headerMenu = document.querySelector(".l-header__mobile");
  const text = jQuery(".l-header .c-animated-text");
  const body = document.body;
  const html = document.documentElement;

  // Menu links for tabindex management
  const menuLinks = headerMenu.querySelectorAll("a");
  // Set initial state: menu closed, links not tabbable
  headerMenu.setAttribute("aria-hidden", "true");
  menuLinks.forEach(link => link.setAttribute("tabindex", "-1"));

  // Function to close menu (reused for click and Escape)
  const closeMenu = () => {
    burger.classList.remove("is-open");
    burger.setAttribute('aria-label', 'Åpne menyen');
    burger.setAttribute("aria-expanded", "false");
    header.classList.remove("is-open");
    headerMenu.setAttribute("aria-hidden", "true");
    menuLinks.forEach(link => link.setAttribute("tabindex", "-1"));
    burger.focus(); // Return focus to burger button
    lenis.start();
    text.removeClass("is-active");
    body.classList.remove("is-overflow-hidden");
    html.classList.remove("is-overflow-hidden");
  };

  // Focus trapping
  const trapFocus = (e) => {
    const focusableElements = headerMenu.querySelectorAll(
      'a[href], button:not([disabled]), [tabindex="0"]'
    );
    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

    if (e.key === "Tab") {
      if (e.shiftKey && document.activeElement === firstFocusable) {
        // Shift+Tab on first element: move to last
        e.preventDefault();
        lastFocusable.focus();
      } else if (!e.shiftKey && document.activeElement === lastFocusable) {
        // Tab on last element: move to first
        e.preventDefault();
        firstFocusable.focus();
      }
    } else if (e.key === "Escape") {
      // Close menu on Escape
      closeMenu();
      headerMenu.removeEventListener("keydown", trapFocus); // Clean up
    }
  };

  burger.addEventListener("click", () => {
    if (burger.classList.contains("is-open")) {
      closeMenu();
      // Remove focus trap
      headerMenu.removeEventListener("keydown", trapFocus);
    } else {
      burger.classList.add("is-open");
      burger.setAttribute('aria-label', 'Lukk menyen');
      burger.setAttribute("aria-expanded", "true");
      header.classList.add("is-open");
      headerMenu.setAttribute("aria-hidden", "false");
      menuLinks.forEach(link => link.removeAttribute("tabindex"));
      // Move focus to first menu item
      const firstMenuItem = headerMenu.querySelector("a[href], button");
      if (firstMenuItem) firstMenuItem.focus();
      // Add focus trap
      headerMenu.addEventListener("keydown", trapFocus);
      lenis.stop();
      text.addClass("is-active");
      body.classList.add("is-overflow-hidden");
      html.classList.add("is-overflow-hidden");
    }
  });
}

export default burgerMenu;